import React from "react";

const ChangePassword = () => {
  return <div>ChangePassword</div>;
};

export default ChangePassword;

// // ChangePassword.js
// import React, { useState } from "react";
// import { useChangePasswordMutation } from "../slices/authSlice";
// import Input from "../components/utilComponents/Input";
// import Button from "../components/utilComponents/Button";

// const ChangePassword = () => {
//   const [oldPassword, setOldPassword] = useState("");
//   const [newPassword, setNewPassword] = useState("");
//   const [confirmNewPassword, setConfirmNewPassword] = useState("");
//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState("");
//   const [success, setSuccess] = useState("");
//   const [changePassword] = useChangePasswordMutation();

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     if (newPassword !== confirmNewPassword) {
//       setError("New passwords do not match");
//       return;
//     }
//     setLoading(true);
//     setError("");
//     setSuccess("");
//     try {
//       await changePassword({ oldPassword, newPassword }).unwrap();
//       setSuccess("Password changed successfully");
//       setOldPassword("");
//       setNewPassword("");
//       setConfirmNewPassword("");
//     } catch (error) {
//       setError("Error changing password");
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <div className="flex flex-col items-center justify-center min-h-screen bg-gray-100">
//       <div className="bg-white p-8 rounded shadow-md w-96">
//         {error && <p className="text-red-500 mb-4">{error}</p>}
//         {success && <p className="text-green-500 mb-4">{success}</p>}
//         <form onSubmit={handleSubmit}>
//           <Input
//             type="password"
//             placeholder="Enter old password"
//             value={oldPassword}
//             onChange={(e) => setOldPassword(e.target.value)}
//             isFullWidth
//           />
//           <Input
//             type="password"
//             placeholder="Enter new password"
//             value={newPassword}
//             onChange={(e) => setNewPassword(e.target.value)}
//             isFullWidth
//           />
//           <Input
//             type="password"
//             placeholder="Confirm new password"
//             value={confirmNewPassword}
//             onChange={(e) => setConfirmNewPassword(e.target.value)}
//             isFullWidth
//           />
//           <Button
//             type="submit"
//             variant="primary"
//             isFullWidth
//             isActive={!loading}
//           >
//             {loading ? "Changing..." : "Change Password"}
//           </Button>
//         </form>
//       </div>
//     </div>
//   );
// };

// export default ChangePassword;
